/**
 * Formats the street portion of an address ("Street Number"), dropping the
 * house number when it is missing or the "Unknown" sentinel. Accepts a missing
 * address: not every listing row carries one (area-interest rows anchor on a
 * centroid instead), and a card must degrade to a blank line, not crash.
 */
export const formatStreetLine = (a?: {
  street?: string;
  houseNumber?: string;
}): string =>
  `${a?.street ?? ''}${
    a?.houseNumber && a.houseNumber !== 'Unknown' ? ' ' + a.houseNumber : ''
  }`;

/**
 * Whether an address names a street: not missing, blank or the "Unknown"
 * sentinel. A district-only map selection (JAA-417) has none, so it must not
 * seed a listing or a follow with its address.
 */
export const hasStreetAddress = (a?: { street?: string } | null): boolean =>
  !!a?.street?.trim() && a.street.trim().toLowerCase() !== 'unknown';

/**
 * Formats a full single-line address ("Street Number, City"), dropping empty
 * segments so a missing street or city never leaves a stray comma.
 */
export const formatAddressLine = (a?: {
  street?: string;
  houseNumber?: string;
  city?: string;
}): string =>
  [formatStreetLine(a).trim(), a?.city?.trim()]
    .filter((part) => part)
    .join(', ');
